import { defineMeta } from '@/registry/types';

export const tooltipMeta = defineMeta({
  name: 'Tooltip',
  level: 'atom',
  category: 'feedback',
  classification: 'mui-overrides',
  description: 'Contextual hint on hover/focus. Themed MUI Tooltip with arrow by default.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Tooltip',
  muiDocs: 'https://mui.com/material-ui/react-tooltip/',
  a2uiEquivalent: 'Tooltip',
  importPath: '@/atoms/Tooltip',
  requiredProps: ['title', 'children'],
  optionalProps: ['placement', 'arrow', 'enterDelay'],
  supportedStates: ['hidden', 'visible'],
  designTokens: ['colors', 'radius'],
  accessibility: [
    'Child must be focusable so keyboard users can trigger the tooltip.',
    'Do not put essential information only in a tooltip.',
  ],
  usageExamples: ['<Tooltip title="Refresh"><IconButton>...</IconButton></Tooltip>'],
  antiPatterns: ['Do not wrap disabled elements directly (wrap in a span).'],
  mountsSurface: 'portal',
  llmSafe: true,
  whenToUse: ['Explaining icon buttons or truncated text'],
  whenNotToUse: ['Critical content that must always be visible'],
});

export default tooltipMeta;
